import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { SuperComponent } from 'src/app/pages/super/super.component';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';

@Component({
  selector: 'app-items-search',
  templateUrl: './items-search.component.html',
  styleUrls: ['./items-search.component.scss']
})
export class ItemsSearchComponent extends SuperComponent implements OnInit {
  ItemSForm:any ={};
  seachedItems:any =[];
  SearchedItemsData: any= [];
  itemList: any= [];
  mainColorList: any= [];
  manufactureCompayList: any= [];
  MainDataSizingsList: any= [];
  MainDataScreeningsList: any= [];

  itemgroups : any =[] ;
  ItemGroupId:any;
  ItemId:any; 
  MainDataColorsId:any; 
  MainDataSizingId:any; 
  MainDataScreeningId:any; 
  ManufacturerCompanyId:any; 

  _loaditems : boolean = false
  itemDropdown : any;
  buttonOptions = {
    text: this.translate.instant('tableinfo.search'),
    type: 'default',
    useSubmitBehavior: true,
  };
  

  @Input()
  set loaditems(value: boolean) {
    this._loaditems = value;
    if (this._loaditems) {
      console.log("app-items-search component is now loading...");
      this.initSearch();
    }
  }

  get loaditems(): boolean {
    return this._loaditems;
  }

  @ViewChild(DxDataGridComponent) sharedgrid: DxDataGridComponent;
  constructor(Objects: ObjectsService, translate: TranslateService, gt: genericCustomStoreService, public NotifyService: NotifyService,
    public _publicSettingService: publicSettingService, ) {
    super(Objects, translate, gt)

    this.onValueItemsChanged = this.onValueItemsChanged.bind(this)

  }

  ngOnInit(): void {



  }

  initSearch(){


    this.getItemslistGroup()
    this.getManufactureCompanyList()
    this.getMainColorDataList();
    this.getMainDataSizingsList()
    this.getMainDataScreeningsList()
  this.gt.getdropdowndata("Items").subscribe((res: []) => this.itemDropdown = res)
  }

  getItemslistGroup () {
    this.gt.getdropdowndata("ItemGroup","GetDropDownLast").subscribe((res:any)=>{
      this.itemgroups=res;
      // console.log(" this.itemList", this.itemList)

    })
  }

  getManufactureCompanyList() {
    this.gt.getdropdowndata('ManufacturerCompany').subscribe((res:any)=>{
      this.manufactureCompayList = res;
      // console.log(" this.manufactureCompayList", this.manufactureCompayList)
    })
  }

  getMainColorDataList () {
    this.gt.getdropdowndata('MainDataColors').subscribe((res:any)=>{
      this.mainColorList = res;
      // console.log(" this.mainColorList", this.mainColorList)

    })
  }
  getMainDataSizingsList () {
    this.gt.getdropdowndata('MainDataSizings').subscribe((res:any)=>{
      this.MainDataSizingsList = res;
      // console.log("this.MainDataSizingsList",this.MainDataSizingsList)

    })
  }
  getMainDataScreeningsList () {

    

    this.gt.getdropdowndata('ItemDescriptionType').subscribe((res:any)=>{
      this.MainDataScreeningsList = res;
      // console.log("this.MainDataScreeningsList",this.MainDataScreeningsList)
// 
    })
  }


  onValueItemsChanged (e:any) {
    console.log(this)
    this.ItemId = e.value
  }

  onValueMainColorListChanged (e:any) {
    this.MainDataColorsId = e.value
  }

  onValueMainSizeChanged (e:any) {
    this.MainDataSizingId = e.value
  }

  onValueDataScreeningChanged (e:any) {
    this.MainDataScreeningId = e.value
  }

  onValueMaufacturChanged (e:any) {
    this.ManufacturerCompanyId = e.value
  }


  onFormSubmit(event:any) {
    event.preventDefault();
    console.log(this.ItemSForm)
    this.gt.searchItemsGroup( this.ItemSForm.ItemGroupId, this.ItemSForm.ItemId, this.ItemSForm.MainDataColorsId, this.ItemSForm.MainDataScreeningId, this.ItemSForm.MainDataSizingId, this.ItemSForm.ManufacturerCompanyId).subscribe((res:any)=>{
      this.SearchedItemsData = res;
      console.log("this.seachedItems ", this.seachedItems)
    })
  }
}
